/* tslint:disable */
/* eslint-disable */
/**
 * Metaform REST API
 * REST API for Metaform
 *
 * The version of the OpenAPI document: 2.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum ReplyOrderCriteria {
    Created = 'CREATED',
    Modified = 'MODIFIED'
}

export function ReplyOrderCriteriaFromJSON(json: any): ReplyOrderCriteria {
    return ReplyOrderCriteriaFromJSONTyped(json, false);
}

export function ReplyOrderCriteriaFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReplyOrderCriteria {
    return json as ReplyOrderCriteria;
}

export function ReplyOrderCriteriaToJSON(value?: ReplyOrderCriteria | null): any {
    return value as any;
}

